import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { getUser } from "../utils/auth";
import { ROLE_ACCESS } from "../config/roleAccess";
import { Dialog, DialogContent, Typography, Button } from "@mui/material";

export default function ProtectedRoute({ children }) {
  const user = getUser();
  const location = useLocation();
  const navigate = useNavigate();

  const [showDialog, setShowDialog] = useState(false);

  const allowedRoutes = user ? ROLE_ACCESS[user.role] || [] : [];

  const isAllowed = user
    ? allowedRoutes.some((route) => location.pathname.startsWith(route))
    : false;

  // ✅ ALWAYS call hooks (no conditional placement)
  useEffect(() => {
    if (user && !isAllowed) {
      setShowDialog(true);
    }
  }, [user, isAllowed]);

  // 🚨 Handle login redirect AFTER hooks
  if (!user) return <Navigate to="/login" />;

  // 🚫 Not allowed → show popup
  if (!isAllowed) {
    return (
      <>
        <Dialog open={showDialog}>
          <DialogContent sx={{ textAlign: "center", p: 3 }}>
            <Typography variant="h6" color="error" mb={2}>
              Insufficient Permission
            </Typography>

            <Typography variant="body2" mb={3}>
              You are not authorized to access this page.
            </Typography>

            <Button
              variant="contained"
              onClick={() => navigate(-1)} // 👈 better UX
            >
              Go Back
            </Button>
          </DialogContent>
        </Dialog>
      </>
    );
  }

  return children;
}
